import { ClientEvent } from '@udemy/event-tracking';
/**
 * Fired when a collection list is created
 */
export class LearningListCreateEvent extends ClientEvent {
  constructor({
    listId,
    uiRegion,
    nonInteraction = false
  }) {
    super('LearningListCreateEvent');
    this.listId = void 0;
    this.nonInteraction = void 0;
    this.uiRegion = void 0;
    this.listId = listId;
    this.nonInteraction = nonInteraction;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when a collection list is deleted
 */
export class LearningListDeleteEvent extends ClientEvent {
  constructor({
    listId,
    uiRegion
  }) {
    super('LearningListDeleteEvent');
    this.listId = void 0;
    this.uiRegion = void 0;
    this.listId = listId;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when a collection list is edited
 */
export class LearningListEditEvent extends ClientEvent {
  constructor({
    listId,
    uiRegion
  }) {
    super('LearningListEditEvent');
    this.listId = void 0;
    this.uiRegion = void 0;
    this.listId = listId;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when user attempts to remove a course from the list
 */
export class LearningListItemRemoveEvent extends ClientEvent {
  constructor({
    listId,
    courseId,
    trackingId,
    uiRegion
  }) {
    super('LearningListItemRemoveEvent');
    this.listId = void 0;
    this.uiRegion = void 0;
    this.courseId = void 0;
    this.trackingId = void 0;
    this.listId = listId;
    this.courseId = courseId;
    this.trackingId = trackingId;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when user clicks the "Save To List" button
 */
export class LearningListItemSaveEvent extends ClientEvent {
  constructor({
    listId,
    courseId,
    trackingId,
    uiRegion
  }) {
    super('LearningListItemSaveEvent');
    this.listId = void 0;
    this.uiRegion = void 0;
    this.courseId = void 0;
    this.trackingId = void 0;
    this.listId = listId;
    this.courseId = courseId;
    this.trackingId = trackingId;
    this.uiRegion = uiRegion;
  }
}
//# sourceMappingURL=events.js.map